import { inject, Injectable } from "@angular/core";
import { HttpEvent, HttpHandler, HttpInterceptor, HttpInterceptorFn, HttpRequest } from "@angular/common/http";
import { Observable } from "rxjs";

import { AuthService } from "../services";

@Injectable({
  providedIn: "root",
})
export class HttpAuthHeaderInterceptor implements HttpInterceptor {
  readonly #auth = inject(AuthService);

  intercept(request: HttpRequest<unknown>, next: HttpHandler): Observable<HttpEvent<unknown>> {
    // add session id to http header if exist
    if (this.#auth.getSessionIdFromStorage()) {
      request = request.clone({
        headers: request.headers.set(this.#auth.getSessionIdKey(), this.#auth.getSessionIdFromStorage()),
      });
    }
    return next.handle(request);
  }
}

export const httpAuthHeaderInterceptor: HttpInterceptorFn = (request, next) => {
  const authService = inject(AuthService);
  if (authService.getSessionIdFromStorage()) {
    request = request.clone({
      headers: request.headers.set(authService.getSessionIdKey(), authService.getSessionIdFromStorage()),
    });
  }
  return next(request);
};
